import { defineComponent } from "../../../common/runtime/defineComponent.svelte";

defineComponent({
  tag: "oc-tab-item-v1",
  extendOptions: { useShadow: false },
  props: {
    disabled: { type: "Boolean" },
    ocAriaControls: {},
  },

  component: () => import("./TabItemV1.svelte"),
  styles: () => import("./TabItemV1.global.scss?inline"),
});
